export default __webpack_public_path__ + "static/media/anuoshka.3f4d5ead.png";